import React from 'react';
import clsx from 'clsx';
import styles from './Tabs.module.scss';

interface TabsProps {
    tabId: string;
    selectTabHandler: (tabId: string) => void;
}

export const positiveTabId = 'positive';
export const negativeTabId = 'negative';

export const Tabs: React.FC<TabsProps> = ({ tabId, selectTabHandler }) => {
    return (
        <div className={styles.tabsContainer}>
            <button
                className={clsx(styles.tab, tabId === positiveTabId && styles.active)}
                onClick={() => selectTabHandler(positiveTabId)}
            >
                👍
            </button>
            <button
                className={clsx(styles.tab, tabId === negativeTabId && styles.active)}
                onClick={() => selectTabHandler(negativeTabId)}
            >
                👎
            </button>
        </div>
    );
};

export default Tabs;
